var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSettingsDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.388 12.04-1.998-.435a10.875 10.875 0 0 0-.643-1.55l1.106-1.721a.777.777 0 0 0-.104-.97l-3.113-3.113a.777.777 0 0 0-.97-.104l-1.72 1.106c-.5-.254-1.02-.47-1.551-.643l-.435-1.998A.777.777 0 0 0 17.201 2H12.8a.777.777 0 0 0-.76.612l-.434 1.998c-.532.174-1.05.39-1.55.643L8.333 4.147a.777.777 0 0 0-.97.104L4.251 7.364a.777.777 0 0 0-.104.97l1.106 1.72c-.254.5-.47 1.02-.643 1.551l-1.998.435a.777.777 0 0 0-.612.759V17.2c0 .366.255.682.612.76l1.998.434c.174.532.39 1.05.643 1.55l-1.106 1.721a.777.777 0 0 0 .104.97l3.113 3.113a.777.777 0 0 0 .97.104l1.72-1.106c.5.254 1.02.47 1.551.643l.435 1.998a.777.777 0 0 0 .759.612H17.2a.777.777 0 0 0 .76-.612l.434-1.998c.532-.174 1.05-.39 1.55-.643l1.721 1.106a.777.777 0 0 0 .97-.104l3.113-3.113a.777.777 0 0 0 .104-.97l-1.106-1.72c.254-.5.47-1.02.643-1.551l1.998-.435a.777.777 0 0 0 .612-.759V12.8a.777.777 0 0 0-.612-.76zM19.661 15A4.667 4.667 0 0 1 15 19.661 4.667 4.667 0 0 1 10.339 15 4.667 4.667 0 0 1 15 10.339 4.667 4.667 0 0 1 19.661 15z",
    fill: "#4A606A",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSettingsDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-settings-default.bad74e9a490f9f4979e1010686c6cc3c.svg";